// src/redux/store.ts
import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';

// Configure the store with the user reducer
const store = configureStore({
  reducer: {
    user: userReducer,
  },
});

// Export the types for RootState and AppDispatch
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;